import type { MonitorRecommendList } from '../types';

export const MonitorSuggestRepository = Symbol('MonitorSuggestRepository');

export interface MonitorSuggestRepository {
    getMonitorRecommendList(): Promise<MonitorRecommendList>
}
